import { apiClient } from "./ApiClient";

const AUTH_API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v1/auth`;

export default {
    signIn(user_id, password) {
        return apiClient.post(`${AUTH_API_URL}/sign_in`, { user_id, password });
    },
    signOut() {
        return apiClient.post(`${AUTH_API_URL}/sign_out`);
    }
}